import { useEffect } from 'react'

import {
  $getSelection,
  $insertNodes,
  $isNodeSelection,
  COMMAND_PRIORITY_EDITOR
} from '@eastcoal/editor/exports'
import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { $insertIsolatedNodeToNearestRoot } from '@eastcoal/editor/utils/node'

import {
  $createTextVariableNode,
  TextVariableNode
} from '../../nodes/TextVariableNode'

import { INSERT_TEXT_VARIABLE_COMMAND } from './commands'

export const TextVariablePlugin = () => {
  const editor = useEditor()

  useEffect(() => {
    editor.registerCommand(
      INSERT_TEXT_VARIABLE_COMMAND,
      payload => {
        if (!editor.hasNode(TextVariableNode)) {
          throw new Error(
            'TextVariablePlugin: TextVariableNode not registered on editor'
          )
        }
        const textVariableNode = $createTextVariableNode(payload)
        const selection = $getSelection()
        // 如果当前已经选中了 DecoratorNode，则需要特殊处理
        if ($isNodeSelection(selection)) {
          const node = selection.getNodes()[0]
          const parentNode = node.getParent()
          if (parentNode) {
            parentNode.append(textVariableNode)
          } else {
            $insertIsolatedNodeToNearestRoot(textVariableNode)
          }
        } else {
          $insertNodes([textVariableNode])
        }
        return false
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return null
}
